import { useMemo } from "react"
import { Box, HStack, Text, VStack } from "@chakra-ui/react"
import { DepositForAccount } from "@mezo/api"

import { selectTokenApprovalStatus, useDappSelector } from "#/redux-state"
import TokenAmountInput from "#/shared/components/TokenAmountInput"
import { useStbtcManageForm } from "#/shared/hooks"
import DepositApproveButton from "#/ui-old/Deposit/DepositButtons/DepositApproveButton"

import StbtcModalSubmitButton from "../StbtcModalSubmitButton"

type StbtcReturnFormProps = {
  deposit?: DepositForAccount
}

export default function StbtcReturnForm({ deposit }: StbtcReturnFormProps) {
  const {
    returnReceiptToken,
    maxReturnAmount,
    depositAmount,
    tokenDecimals,
    setDepositTokenAmountCallback,
    additionalValidationCallback,
  } = useStbtcManageForm(deposit)

  const tokenApprovalStatus = useDappSelector(selectTokenApprovalStatus)

  const isButtonBlocked = useMemo(
    () => tokenApprovalStatus !== "approved",
    [tokenApprovalStatus],
  )

  return (
    <form onSubmit={returnReceiptToken}>
      <VStack alignItems="center">
        <Text
          variant="label"
          fontSize="12px"
          fontWeight={500}
          color="primary.black.60"
          fontFamily="riforma.medium"
          alignSelf="start"
        >
          How much would you like to return?
        </Text>
        <Box position="relative" w="100%" mb="32px">
          <TokenAmountInput
            tokenAmount={depositAmount}
            tokenDecimals={tokenDecimals}
            setTokenAmountCallback={setDepositTokenAmountCallback}
            maxTokenAmount={maxReturnAmount}
            placeholder="0"
            precisionAmount={tokenDecimals}
            additionalValidationCallback={additionalValidationCallback}
            withMaxButton
            tokenLabel="stBTC"
          />
        </Box>
        <HStack width="100%" alignItems="end" justifyContent="space-between">
          <DepositApproveButton
            defaultButtonText="1. Approve"
            loaderButtonProps={{ fontSize: "12px" }}
            textAlign="center"
            width="200px"
            blockOnError={false}
            allowApproveRetry={false}
            rejectedStateProps={{
              showIcon: false,
              rejectedText: "Transaction rejected",
              textProps: { fontSize: "12px" },
            }}
            errorStateBelowButton={false}
            customBalance={maxReturnAmount}
          />
          <StbtcModalSubmitButton
            buttonProps={{
              width: "100%",
              isDisabled:
                isButtonBlocked ||
                !Number(depositAmount) ||
                tokenApprovalStatus !== "approved",
            }}
            width="200px"
            loaderButtonProps={{ fontSize: "10px", px: 4 }}
            rejectedButtonProps={{ fontSize: "12px" }}
          >
            2. Return
          </StbtcModalSubmitButton>
        </HStack>
      </VStack>
    </form>
  )
}
